export default "__VITE_ASSET__5c5cfb54__"